import { render, staticRenderFns } from "./expert_case.vue?vue&type=template&id=190bd104&scoped=true"
import script from "./expert_case.vue?vue&type=script&lang=js"
export * from "./expert_case.vue?vue&type=script&lang=js"
import style0 from "./expert_case.vue?vue&type=style&index=0&id=190bd104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190bd104",
  null
  
)

export default component.exports